import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import{userService, LoopBackAuth} from '../../services/api-rest.service';
import{MessageService} from '../../services/message.service';
import { Router }   from '@angular/router';
import { isNull } from 'util';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { ModalMensajeConfirmacionComponent } from '../../../shared/modal/modal-mensaje-confirmacion/modal-mensaje-confirmacion.component';
import { ModalMensajeUsuarioComponent } from '../../../shared/modal/modal-mensaje-usuario/modal-mensaje-usuario.component';

@Component({
  selector: 'modal-modificar-contrasenia',
  templateUrl: './modal-modificar-contrasenia.component.html',
  styleUrls: ['./modal-modificar-contrasenia.component.css'],
  providers:[LoopBackAuth,userService,MessageService]
})
export class ModalModificarContraseniaComponent implements OnInit {
  @Input() spinnerLoad: any
  formCambio : FormGroup
  mensaje: string
  contador : number =0;
  activar : boolean = false;
  spinner = true;
  constructor(
    public activeModal: NgbActiveModal,
    private LoopBackAuth:LoopBackAuth,
    public fb: FormBuilder,
    public userService: userService,
    private modalService: NgbModal,
    public router: Router) { }

  ngOnInit() {
    this.formCambio = this.fb.group({
      contrasenia:[null,Validators.required],
      nuevaContasenia:[null,Validators.required],
      confirmacion:[null,Validators.required]
    })
    //this.validarActivacionInput()
  }

  validarActivacionInput(){
    if(!this.formCambio.get('contrasenia').valid ){
      this.formCambio.get('nuevaContasenia').disable()
      this.formCambio.get('confirmacion').disable()
      this.formCambio.get('nuevaContasenia').reset()
      this.formCambio.get('confirmacion').reset()
      this.activar = false
      this.mensaje = ""
    }

    //this.spinnerLoad.isSpinnerVisible = true
    this.userService.verificarClaveAnterior(this.formCambio.get('contrasenia').value).subscribe(
      result => {
        if(!isNull(result)){
          this.formCambio.get('nuevaContasenia').enable()
          this.formCambio.get('confirmacion').enable()
          this.activar = true
        }
        //this.spinnerLoad.isSpinnerVisible = false
      }
    )
  }
  ngConfirmacion(){
    var password = this.formCambio.get('nuevaContasenia').value
    var lMayuscula = (password.match(new RegExp(/[A-Z]/g)) != null)?password.match(new RegExp(/[A-Z]/g)):''
    var lMinuscula = (password.match(new RegExp(/[a-z]/g)) != null)? password.match(new RegExp(/[a-z]/g)):''
    var numeros = (password.match(new RegExp(/[0-9]/g)) != null )?password.match(new RegExp(/[0-9]/g)):''
    var especiales =  (password.match(new RegExp(/[\^$.*+?=!:|\\/()\[\]{}]/g)) != null )? password.match(new RegExp(/\*/g)):''
    var minChar = 10
    this.mensaje = ""
    this.contador = 0
   
    if(lMayuscula.length > 0 )
      this.contador = this.contador +1
  
    if(lMinuscula.length > 0 )
      this.contador = this.contador +1
      
    if(numeros.length > 0 )
      this.contador = this.contador +1
    
    if(especiales.length > 0 )
      this.contador = this.contador +1
    
    if(password.length >= minChar )
      this.contador = this.contador +1
  
    if(this.contador > 0 && this.contador <= 1)
      this.mensaje = "Baja"
    if(this.contador > 1 && this.contador <= 3)
      this.mensaje = "Media"
    if(this.contador > 3 && this.contador <= 6)
      this.mensaje = "Alta"

    console.log("Contador -->", this.contador)
  }

  guardar(){
    this.spinner = false
    this.userService.verificarClaveAnterior(this.formCambio.get('contrasenia').value).subscribe(
      result => {
        if(!isNull(result)){
          const ventana = this.modalService.open(ModalMensajeConfirmacionComponent,{size:'sm'})
          ventana.componentInstance.titulo = "Cambiar de contraseña"
          ventana.componentInstance.mensaje = "Estas seguro en cambiar la contraseña de tu usuario, al cambiarlo se reiniciara la sesión y te solicitará nuevamente ingresar"
          ventana.result.then(
          (result) => {
            this.spinner = false
            this.userService.changePassword(this.formCambio.get('contrasenia').value, this.formCambio.get('nuevaContasenia').value).subscribe(
              mensaje=>{
                if(mensaje != null){
                  this.userService.logout().subscribe(
                    mensaje =>{
                      if(!isNull(mensaje)){
                        this.LoopBackAuth.remove()
                        this.router.navigate(['/'])
                        this.activeModal.close();
                        //if(mensaje != null) this.activeModal.close();
                      }
                    }
                  )
                }
                this.spinner = true   
              }
            )
          });
          this.spinner = true 
        }else{
          const ventanaNotas = this.modalService.open(ModalMensajeUsuarioComponent, {size:'sm'})
          ventanaNotas.componentInstance.mensaje = "La contraseña actual no es valida"
          ventanaNotas.componentInstance.icono = 'icofont icofont-document-search'
          this.spinner = true
        }
      }
    )

    
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal-modificar-contrasenia/modal-modificar-contrasenia.component.ts